import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import type { PortManageStatCardKey } from './port-manage-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    riskPorts: { default: 0 },
    blockedPorts: { default: 0 }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emit = __emit

const statisticsItems = computed((): StatisticsCardItem[] => {
  void locale.value
  const risk = props.riskPorts ?? 0
  const blocked = props.blockedPorts ?? 0
  return [
    {
      label: t('portManage.riskPort'),
      value: risk,
      span: 12,
      clickable: risk > 0,
      events: {
        click: () => {
          if (risk <= 0) return
          emit('statClick', 'riskPorts')
        }
      }
    },
    {
      label: t('portManage.blockedPort'),
      value: blocked,
      span: 12,
      clickable: blocked > 0,
      events: {
        click: () => {
          if (blocked <= 0) return
          emit('statClick', 'blockedPorts')
        }
      }
    }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})